import {
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Text,
  ListItem,
  UnorderedList,
} from '@chakra-ui/react';
import { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { GlobalContext } from 'providers/Global';
import { ModalType, SCREEN_MD } from '../../utils/constants';

const AboutModal = () => {
  const {
    modals: {
      [`${ModalType.AboutModal}`]: { open },
    },
    closeModal,
  } = useContext(GlobalContext);

  const isMobile = useMediaQuery({ query: `(max-width: ${SCREEN_MD})` });

  return (
    <Drawer
      isOpen={open}
      onClose={() => closeModal(ModalType.AboutModal)}
      placement="right"
      size={isMobile ? 'full' : 'lg'}
    >
      <DrawerOverlay backdropFilter="blur(10px)" />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader borderBottomWidth="1px">
          <Text variant="bodyBold" fontSize="xl">
            About Hedera MultiSig
          </Text>
        </DrawerHeader>
        <DrawerBody py={6}>
          <Box display="flex" flexDirection="column" gap={5}>
            <Text fontWeight={600} fontSize="md">
              The Multisig Paradox: Security vs. Complexity
            </Text>
            <Text fontSize="sm" color="blackAlpha.700" lineHeight="tall">
              Multi-signature accounts are solutions that bring security,
              eliminate single points of failure, and facilitate shared control
              of assets in blockchain networks. However, as economist Thomas
              Sowell noted:
            </Text>
            <Text fontSize="sm" color="blackAlpha.700" fontStyle="italic" lineHeight="tall">
              "There are no solutions, only trade-offs."
            </Text>
            <Text fontSize="sm" color="blackAlpha.700" lineHeight="tall">
              The current multisig approach comes with significant operational
              complexity, high transaction costs, and a high risk of user error.
              These barriers have turned a powerful security tool into a source
              of friction, stifling adoption and leaving teams frustrated.
            </Text>

            <Text fontWeight={600} fontSize="md">
              Bringing Clarity and Confidence to Teams with Hedera MultiSig
            </Text>
            <Text fontSize="sm" color="blackAlpha.700" lineHeight="tall">
              As key development partners for Hedera, LimeChain recognized a
              critical need for a more accessible way to operate within the
              ecosystem.
            </Text>
            <Text fontSize="sm" color="blackAlpha.700" lineHeight="tall">
              Hedera MultiSig is our way to introduce simplicity, clarity, and
              confidence in how teams create, protect, and manage digital assets
              on the Hedera network.
            </Text>

            <Text fontWeight={600} fontSize="md">
              Our Mission
            </Text>
            <Text fontSize="sm" color="blackAlpha.700" lineHeight="tall">
              To make advanced multi-signature security intuitive and accessible
              for everyone on the Hedera network.
            </Text>

            <Text fontWeight={600} fontSize="md">
              What Hedera MultiSig Brings to the Network
            </Text>
            <UnorderedList spacing={3} pl={2}>
              <ListItem fontSize="sm" color="blackAlpha.700" lineHeight="tall">
                <Text as="span" fontWeight={600} color="blackAlpha.800">
                  Collaborative Management:
                </Text>{' '}
                Hedera MultiSig empowers teams to establish shared wallets where
                transactions require collective approval.
              </ListItem>
              <ListItem fontSize="sm" color="blackAlpha.700" lineHeight="tall">
                <Text as="span" fontWeight={600} color="blackAlpha.800">
                  Reduced Risk:
                </Text>{' '}
                We've stripped away the complexity that leads to user error,
                allowing you to focus on managing your assets rather than
                fighting the interface.
              </ListItem>
              <ListItem fontSize="sm" color="blackAlpha.700" lineHeight="tall">
                <Text as="span" fontWeight={600} color="blackAlpha.800">
                  Ecosystem-Specific Design:
                </Text>{' '}
                Hedera MultiSig is built specifically for Hedera users, by
                Hedera experts.
              </ListItem>
            </UnorderedList>
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default AboutModal;
